@if (rapport.specificatieScholing?.opbouw?.totaalScholingsaftrek) {
  <form [formGroup]="specScholingFormGroup">
    <div class="row">
      <div formGroupName="specificatieScholing">
        <div formGroupName="opbouw">
          <div>
            <div class="row">
              <div class="col col-1">
                <p><b>Aftrekbare scholingskosten</b></p>
              </div>
              <div class="col-2">
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  align="right"
                  class="custom-input-150"
                  formControlName="aftrekbaarAangever"
                  id="aftrekbaarAangever"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
              <div class="col-2"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
}
